import React from 'react';

/**
 * Public-site temporary-unavailable notice.
 *
 * Rendered for every non-admin route while the public VisaSG website is
 * taken offline. Admin surfaces (`/admin/**`) continue to route through
 * their existing pages exactly as before — this component is only
 * mounted under public routes in App.js.
 *
 * Do not add navigation, links to old public pages, or references to
 * visa services. The wording below is fixed per the site owner's brief.
 */
export default function TemporaryUnavailable() {
  return (
    <main
      className="min-h-screen w-full grid place-items-center bg-white px-6"
      data-testid="temporary-unavailable-page"
    >
      <div className="max-w-xl w-full text-center py-16">
        <img
          src="/brand/visasg-logo.png"
          alt="VisaSG"
          className="h-14 md:h-16 w-auto object-contain mx-auto"
        />

        <h1
          className="mt-10 font-display text-3xl md:text-4xl text-neutral-900 leading-tight"
          data-testid="temporary-unavailable-heading"
        >
          Website Temporarily Unavailable
        </h1>

        <p
          className="mt-5 text-neutral-700 text-base leading-relaxed"
          data-testid="temporary-unavailable-body"
        >
          Our online services are currently unavailable while we update our website and services.
        </p>

        <div className="mt-10 rounded-2xl border border-neutral-200 bg-neutral-50 p-6 text-left">
          <div className="text-[11px] uppercase tracking-[0.14em] text-neutral-500 font-medium">
            For travel-related enquiries, please contact:
          </div>
          <div className="mt-3 font-display text-lg text-neutral-900">Waan Travel Pte. Ltd.</div>
          <div className="mt-3 text-sm text-neutral-800">
            <div>
              Email:{' '}
              <a
                href="mailto:admin@waantravel.com"
                className="underline hover:text-teal-800"
                data-testid="temporary-unavailable-email-link"
              >
                admin@waantravel.com
              </a>
            </div>
            <div className="mt-1">
              Website:{' '}
              <a
                href="https://www.waantravel.com"
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:text-teal-800"
                data-testid="temporary-unavailable-website-link"
              >
                www.waantravel.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
